import React from 'react';
import ReactApexChart from "react-apexcharts"

const MyProgressOnsite = (props) => {

  const normalizeScore = value => {
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) return 0;
    return Math.max(0, Math.min(100, Math.round(numberValue)));
  };

  const zoomAttend = normalizeScore(props.zoomAttend);
  const assigments = normalizeScore(props.assigments);

  const series = [zoomAttend, assigments, 0]
  const options = {
    chart: {
      toolbar: {
        show: false
      },
      fontFamily: 'Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    },
    plotOptions: {
      radialBar: {
        startAngle: -120,
        endAngle: 240,
        hollow: {
          size: '38%',
          background: '#f8fafc'
        },
        track: {
          background: '#e2e8f0',
          strokeWidth: '95%'
        },
        dataLabels: {
          name: {
            fontSize: '13px',
            color: '#334155',
            fontWeight: 600
          },
          value: {
            fontSize: '18px',
            color: '#0f172a',
            fontWeight: 700,
            formatter: val => `${Math.round(val)}%`
          },
          total: {
            show: true,
            label: 'Overall Progress',
            color: '#475569',
            fontSize: '12px',
            formatter: function (w) {
              const average = w.globals.series.reduce((acc, value) => acc + value, 0) / w.globals.series.length;
              return `${Math.round(average)}%`;
            }
          }
        }
      }
    },
    labels: ['Class Attendance', 'Assignment', 'Project'],
    colors: ['#2563eb', '#10b981', '#94a3b8'],
    stroke: {
      lineCap: 'round'
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      labels: {
        colors: '#475569'
      },
      markers: {
        width: 10,
        height: 10,
        radius: 12
      }
    }
  }

  return (
    
      
      <ReactApexChart
      options={options}
      series={series}
      type="radialBar"
      height="280"
      className="apex-charts"
    />
   
   
  )
}

export default MyProgressOnsite
